import apiClient from './apiClient';

// =====================================================
// GOODS TRANSFER REPORTS
// =====================================================

export const getGtOperations = async () => {
  const response = await apiClient.get('/goods-transfer/reports/operations');
  return response.data;
};

export const getGtEnhancedSummary = async (params = {}) => {
  const response = await apiClient.get('/goods-transfer/reports/enhanced-summary', { params });
  return response.data;
};

export const getGtTransactions = async (params = {}) => {
  const response = await apiClient.get('/goods-transfer/reports/transactions', { params });
  return response.data;
};

export const getGtClosingStock = async (params = {}) => {
  const response = await apiClient.get('/goods-transfer/reports/closing-stock', { params });
  return response.data;
};
